import type { SubscriptionPlan } from '@/types/billing';

// Trial credit allowance for a plan. Mirrors the server-side default in
// subscription-management and stripe-webhook-handler: metadata.trial_credit_cap,
// falling back to 25 when unset. Only meaningful when plan.has_trial is true.
export function getTrialCreditCap(plan: SubscriptionPlan): number {
  const raw = plan.metadata?.trial_credit_cap;
  const parsed = Number(raw);
  return raw !== null && raw !== undefined && Number.isFinite(parsed) ? parsed : 25;
}
